<template>
	<div class="tablediv">
		<el-skeleton :rows="20" :loading="loadingMask" animated :throttle="500">
			<!-- <el-switch class="tableswitch"
				v-show="resultDataYearList.length>0&&resultDataMonthList.length>0"
			  v-model="showType"
			  active-color="#2C68FF"
			  inactive-color="#2C68FF"
			  active-text="月度数据"
			  inactive-text="年度数据">
			</el-switch> -->
			<ul class="tab1" v-show="(resultDataYearList&&resultDataYearList.length>0)&&(resultDataMonthList&&resultDataMonthList.length>0)">
				<li @click="showType=false" :class="showType==false?'curr':''"><span>年度数据</span></li>
				<li @click="showType=true" :class="showType==true?'curr':''"><span>月度数据</span></li>
			</ul>
			<el-table id="filterTable" ref="filterTableStructure" :data="showType?resultDataMonthList:resultDataYearList"  max-height="800" border="true">
				<el-table-column
					v-if="!tableshowtype"
					prop="areaName"
					label="地区"
					min-width="150">
				</el-table-column>
				<el-table-column
					v-if="showType"
					label="时间"
					min-width="150">
					<template slot-scope="scope">
						{{ scope.row.datayear+'年 '+scope.row.dataMonth+'月' }}
					</template>
				</el-table-column>
				<el-table-column
					v-else
					prop="datayear"
					label="时间"
					min-width="150">
				</el-table-column>
				<el-table-column v-for="(item,index) in (showType?resultMonthHeadList:resultYearHeadList)"
					:prop="item" 
					:label="item"
					min-width="220"
					:formatter="emptyformatter">
					<template slot-scope="scope">
						<template v-if="typeof scope.row[item] =='object'">
							{{ scope.row[item][0]==''?'/':scope.row[item][0] }}
							<el-tooltip effect="dark" :content="scope.row[item][1]" placement="right" :visible-arrow="false">
								<i class="el-icon-question"></i>
							</el-tooltip>
							<!-- <el-popover trigger="hover" placement="top">
								<p>{{ scope.row[item][1] }}</p>
								<div slot="reference" class="name-wrapper">
									<i class="el-icon-info"></i>
								</div>
							</el-popover> -->
						</template>
						<template v-else>{{ scope.row[item]==''?'/':scope.row[item] }}</template>
					</template>
				</el-table-column>
			</el-table>
		</el-skeleton>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableid:'',
				tablename:'',
				loadingMask: true,
				resultDataYearList: [],
				resultDataMonthList: [],
				showType:false,
				resultDataShowList: [],
				resultYearHeadList: [],
				resultMonthHeadList: [],
			}
		},
		props: [
			'colid',
			'tableshowtype',
		],
		components: {},
		watch: {
			colid() {
				this.searchfnc();
			}
		},
		created: function() {

		},
		mounted: function() {
			this.searchfnc();
		},
		methods: {
			searchfnc: function() {
				if (this.colid) {
					this.tableid=this.colid.split('_')[0];
					this.tablename=this.colid.split('_')[1];
					let _this = this;
					_this.loadingMask = true;
					_this.resultDataYearList = [];
					_this.resultDataMonthList = [];
					_this.resultYearHeadList = [];
					_this.resultMonthHeadList = [];
					this.$http({
							method: 'get',
							url: 'szjjchart/selectchartstructurebyparentid',
							responseType: 'json',
							params: {
								parentID: this.tableid,
								tableName:this.tablename,
							},
						})
						.then(function(response) {
							_this.showType=false;
							_this.resultDataYearList = response.data.data.data['年'];
							_this.resultDataMonthList = response.data.data.data['月'];
							var tempmenuyeararr=[];
							var tempmenumontharr=[];
							if(!_this.resultDataYearList){
								_this.showType=true;
							}
							
							if(_this.resultDataYearList&&_this.resultDataYearList.length>0){
								tempmenuyeararr=Object.keys(_this.resultDataYearList[0]);
								if(tempmenuyeararr.length>0){
									for(var i=0;i<tempmenuyeararr.length;i++){
										if(['annual','areaName','dataMonth','datayear','unit','areacode'].indexOf(tempmenuyeararr[i])<0){
											_this.resultYearHeadList.push(tempmenuyeararr[i]);
										}
									}
								}
							}
							
							if(_this.resultDataMonthList&&_this.resultDataMonthList.length>0){
								tempmenumontharr=Object.keys(_this.resultDataMonthList[0]);
								if(tempmenumontharr.length>0){
									for(var i=0;i<tempmenumontharr.length;i++){
										if(['annual','areaName','dataMonth','datayear','unit','areacode'].indexOf(tempmenumontharr[i])<0){
											_this.resultMonthHeadList.push(tempmenumontharr[i]);
										}
									}
								}
							}

							
							
							_this.$nextTick(function(){
								_this.$refs.filterTableStructure.doLayout();
							})
							
							_this.loadingMask = false;
						})
						.catch(function(error) {
							_this.loadingMask = false;
							console.log(error);
						});
				}
			},
			emptyformatter(row, column, cellValue, index) {
				// debugger
				if(!cellValue){
					return '/';
				}
				else{
					return cellValue;
				}
			},
		}
	}
</script>

<style>
</style>
